/**
 * 去除字符串前后空格
 * @param value - 字符串值
 * @returns 去除前后空格后的字符串，如果为空字符串则返回 undefined
 */
export function trimString(value: string | undefined | null): string | undefined {
  if (value === undefined || value === null) {
    return undefined;
  }
  const trimmed = value.trim();
  return trimmed === '' ? undefined : trimmed;
}

/**
 * 去除字符串数组中的每个元素的前后空格，并过滤掉空字符串
 * @param values - 字符串数组
 * @returns 处理后的字符串数组，如果数组为空则返回 undefined
 */
export function trimStringArray(
  values: string[] | undefined | null
): string[] | undefined {
  if (!values?.length) {
    return undefined;
  }
  
  const trimmed = values
    .map((v) => v?.trim() ?? '')
    .filter((v) => v !== '');
    
  return trimmed.length === 0 ? undefined : trimmed;
}

/**
 * 处理搜索参数，去除指定字段的前后空格
 * @param params - 搜索参数对象
 * @param fields - 需要处理的字段名数组
 * @returns 处理后的参数对象
 */
export function trimSearchParams<T extends Record<string, any>>(
  params: T,
  fields: (keyof T)[]
): T {
  const result = { ...params };
  
  for (const field of fields) {
    const value = result[field];
    if (value === undefined || value === null) {
      continue;
    }
    
    if (Array.isArray(value)) {
      result[field] = trimStringArray(value) as T[keyof T];
    } else if (typeof value === 'string') {
      result[field] = trimString(value) as T[keyof T];
    }
  }
  
  return result;
}

